import React, { useEffect, useState } from 'react';
import Helpers from 'utils/helpers';
import Inputs from 'components/inputs/inputs';
import useInput from 'hooks/input';
import DistributorModal from './distributorModal';
import './distributorFormControl.css';

export default function DistributorFormControl(props) {
  const [showSitesPopup, setShowSitesPopup] = useState(false);
  const [recipientsList, setRecipientsList] = useState([]);

  const disabled = props.disabled || false;
  const recipientsSelected = props.defaultValues?.subscribers || [];
  const selectedObjects = recipientsList.filter((item) => recipientsSelected.indexOf(item.communicationId) !== -1);
  const required = Helpers.Object.exists(props.required);
  const isInvalid = required && selectedObjects.length === 0;

  const { setInputRef } = useInput({ hasCustomError: isInvalid, customError: 'At last one recipient is required' });

  useEffect(() => {
    setRecipientsList(props.recipientsList);
  }, [props.recipientsList]);

  const handleClose = () => {
    setShowSitesPopup(false);
  };

  const handleChange = (selections, recipients) => {
    setRecipientsList(recipients);
    props.onChange(selections, recipients);
  };

  const handleRemoveItem = (communicationId) => {
    const selections = recipientsSelected.filter((recipientId) => recipientId !== communicationId);
    props.onChange(selections, recipientsList);
  };

  const getClass = () => {
    const classNames = ['distributor-form-control'];
    if (disabled) {
      classNames.push('disabled');
    }
    if (isInvalid) {
      classNames.push('is-invalid');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <>
      <div className={getClass()}>
        {selectedObjects.map((item) => (
          <DistributorBubbleItem
            key={item.communicationValue}
            onRemove={handleRemoveItem}
            communicationId={item.communicationId}
            communicationValue={item.communicationValue}
            disabled={disabled}
          />
        ))}
        {selectedObjects.length === 0 ? <div className='px-3 py-2 opacity-90'>No Recipients</div> : null}
      </div>
      <div className='d-flex justify-content-between w-100'>
        {isInvalid && <div className='invalid-feedback distributor-feedback'>At last one recipient is required</div>}
        <div></div>
        {disabled ? null :
          <div className='text-right'>
            <Inputs.Button variant='form' className='mt-2 mx-0' iconClass='icons8-registration' label='Select Recipients' onClick={() => setShowSitesPopup(true)} />
          </div>
        }
      </div>
      {isInvalid && <input type='text' className='d-none' ref={setInputRef} />}
      {disabled ? null :
        <DistributorModal
          show={showSitesPopup}
          onClose={handleClose}
          onChange={handleChange}
          recipientsSelected={recipientsSelected}
          recipientsList={recipientsList}
          onCreateRecipient={props.onCreateRecipient}
        />
      }
    </>
  );
}

function DistributorBubbleItem(props) {
  const handleDeleteClicked = (e) => {
    e.stopPropagation();
    if (props.onRemove) {
      props.onRemove(props.communicationId);
    }
  };

  return (
    <div className='distributor-bubble-item'>
      <span>{props.communicationValue}</span>
      {props.disabled ? null :
        <i className='icons8-delete distributor-bubble-remove-button' onClick={handleDeleteClicked} />
      }
    </div>
  );
}